import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { ActivatedRoute } from '@angular/router';
import { Auth0User } from '../shared/models/auth0User';
import {
  passwordStrengthValidator,
  passwordMismatchValidator,
  PasswordStrengthError,
  PasswordMismatchError,
} from './password-validator';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnInit {
  private secureLinkId: string;
  private _auth0User: Auth0User;
  recaptchaSiteKey: string;
  passwordForm: UntypedFormGroup;

  constructor(
    public authService: AuthService,
    private appConfigService: AppConfigService,
    private auth0Service: Auth0Service,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.recaptchaSiteKey = this.appConfigService.config.recaptchaSiteKey;
    this.route.params.subscribe((params) => {
      this.secureLinkId = params['secureLinkId'];
    });

    this.auth0Service.getBySecureLinkId(this.secureLinkId).subscribe((res) => {
      this._auth0User = res;
    });
  }

  private buildForm() {
    this.passwordForm = this.formBuilder.group(
      {
        password: [null, [passwordStrengthValidator]],
        confirmPassword: [null, [passwordStrengthValidator]],
        recaptcha: [null, Validators.required],
      },
      { validator: passwordMismatchValidator }
    );
  }

  get haveData(): boolean {
    return !!this._auth0User;
  }

  get accountName(): string {
    return this._auth0User?.tenantName;
  }

  get accountUrl(): string {
    return this._auth0User?.tenantBaseWebUrl;
  }

  get userEmail(): string {
    return this._auth0User?.email;
  }

  get passwordStrengthError(): string {
    return PasswordStrengthError;
  }

  get passwordMismatchError(): string {
    return PasswordMismatchError;
  }

  set auth0User(user: Auth0User) {
    this._auth0User = user;
  }

  isSubmitEnabled() {
    return this.passwordForm.valid;
  }

  onSubmit() {
    if (this.isSubmitEnabled()) {
      this._auth0User.password = this.passwordForm.get('password').value;
      this.auth0Service.setPassword(this.secureLinkId, this._auth0User).subscribe((res: any) => {
        const success = res.success;
        const errorMessages = res.errorMessages;
        if (success === false && errorMessages.length) {
          this.auth0Service.openSnackBar(errorMessages, false);
        } else if (success === true) {
          this.authService.login();
        }
      });
    }
  }
}
